import { render, staticRenderFns } from "./MypagePaidPlanChangeEditPage.vue?vue&type=template&id=49627568"
import script from "./MypagePaidPlanChangeEditPage.vue?vue&type=script&lang=ts"
export * from "./MypagePaidPlanChangeEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports